const Footer = () => {
  return (
    <footer>
      <a 
        href='https://www.artstation.com/artwork/wxJoX' 
        target='_blank' 
        rel='noreferrer'
      >
        Background Image by Mayank Kumarr
      </a>
    </footer>
  )
}

export default Footer